/* eslint-disable no-undef */
import axios from "axios";


export type LookupContactsByResident = {
    value: string, label:string
}


export const getUserLookupContactsByResident = async (email:string) => {
    return await axios({
		url: `/User/LookupContactsByResident?loginEmail=${email}`,
		method: "GET",
	});
}
